export default __webpack_public_path__ + "static/media/eye.b1238fb7.svg";